module.exports = __webpack_public_path__ + "static/manabu-45154af6c3032a68f053c297cae13253.svg";